import React from 'react';

import './Footer.scss';

const ContainerExampleText = () => (
  <footer className="Footer">
    Made by <a href="https://yiotis.net">Yiotis Kaltsikis</a>. MIT License.
  </footer>
);

export default ContainerExampleText;
